// Series 76 banned plates — sourced via the live page at
// https://www.regtransfers.co.uk/content/banned-76-dvla-plates
// (RegTransfers FOI request to the DVLA, published March 2026).
//
// Fetched 2026-05-12 via browser automation through Cloudflare's JS
// challenge (the page is protected; the Plato scraper uses a similar
// real-browser path for /search/... endpoints).
//
// Format:
//   BANNED_76_PLATES — 513 specific combinations as displayed on the
//   regtransfers page. Some entries contain a trailing asterisk
//   (e.g. "BJ76 AY*") meaning the last letter is wildcarded — these are
//   treated as non-navigable in the UI (no /compare deep-link).
//
//   BANNED_76_WILDCARDS — 10 leading-asterisk patterns. Single asterisk
//   means any first letter triggers the ban for that suffix; double
//   asterisk means any first TWO letters.
//
// Categorisation (handoff §5.3) has not run yet, so the page renders
// these as a single ungrouped list. When the classifier output lands,
// add a BANNED_76_GROUPS export here and the template swaps to grouped
// rendering automatically.

export const BANNED_76_PLATES: string[] = [
  'AA76 LAH', 'AA76 RSE', 'AA76 RYN', 'AA76 YAN', 'AC76 AZA', 'AC76 HAD',
  'AD76 RKY', 'AF76 GAT', 'AF76 GGY', 'AF76 GUT', 'AF76 OTT', 'AG76 HAD',
  'AJ76 HAD', 'AR76 RSE', 'AS76 ABY', 'AS76 AST', 'AS76 BOY', 'AS76 FKT',
  'AS76 FKU', 'AS76 FWC', 'AT76 CKU', 'AT76 KMP', 'AT76 KPM', 'AT76 KUU',
  'AU76 WTZ', 'AW76 NKR', 'BJ76 AG*', 'BJ76 ALL', 'BJ76 ALS', 'BJ76 ALZ',
  'BJ76 AY*', 'BJ76 HOT', 'BJ76 LOW', 'BJ76 ONK', 'BJ76 OOB', 'BJ76 OYO',
  'BJ76 OYS', 'BJ76 OYX', 'BJ76 OYY', 'BJ76 OYZ', 'BJ76 RLS', 'BJ76 RLY',
  'BJ76 RLZ', 'BJ76 STD', 'BJ76 STY', 'BJ76 UNK', 'BJ76 USH', 'BJ76 UYE',
  'BJ76 UYS', 'BJ76 UYX', 'BJ76 UYY', 'BJ76 UYZ', 'BL76 CKY', 'BU76 AYS',
  'BU76 AYX', 'BU76 AYY', 'BU76 AYZ', 'BU76 DCK', 'BU76 DKS', 'BU76 GAY',
  'BU76 MUF', 'BU76 NOB', 'BU76 ONK', 'BU76 OYS', 'BU76 OYX', 'BU76 OYY',
  'BU76 SHT', 'BU76 UNK', 'BU76 USH', 'BU76 VAJ', 'BY76 RUS', 'BY76 UKR',
  'CC76 OON', 'CO76 ASH', 'CU76 ASH', 'CU76 AYS', 'CU76 AYX', 'CU76 AYY',
  'CU76 AZA', 'CU76 FGM', 'CU76 HER', 'CU76 JAP', 'CU76 JUW', 'CU76 LEZ',
  'CU76 MPX', 'CU76 MUF', 'CU76 NGR', 'CU76 NOB', 'CU76 PAK', 'CU76 PKY',
  'CU76 VAG', 'CU76 VAJ', 'DD76 RKY', 'EA76 ASH', 'EA76 BUT', 'EA76 COX',
  'EA76 DCK', 'EA76 DKS', 'EA76 DYK', 'EA76 FWF', 'EA76 JUW', 'EA76 LEZ',
  'EA76 LSD', 'EA76 MUF', 'EA76 NOB', 'EA76 OOB', 'EA76 POO', 'EA76 PWP',
  'EA76 SHT', 'EA76 VAG', 'EA76 VAJ', 'EU76 GON', 'EU76 OMB', 'EU76 ONE',
  'EU76 RMY', 'EU76 RUS', 'EU76 UKR', 'FA76 ASH', 'FA76 ATS', 'FA76 ATT',
  'FA76 ATZ', 'FA76 GGY', 'FA76 HAG', 'FA76 JUW', 'FA76 NOB', 'FA76 OTE',
  'FA76 OTS', 'FA76 OTT', 'FA76 OTX', 'FA76 OTZ', 'FA76 VAG', 'FA76 VAJ',
  'FA76 WAH', 'FA76 YPS', 'FA76 YPX', 'FF76 GAT', 'FK76 ABY', 'FK76 ASH',
  'FK76 AZA', 'FK76 ENT', 'FK76 FWF', 'FK76 HAD', 'FK76 MUF', 'FK76 NUS',
  'FK76 ODS', 'FK76 ODX', 'FK76 ODZ', 'FK76 OMB', 'FK76 OVT', 'FK76 OVV',
  'FK76 RUS', 'FK76 UKR', 'FK76 VAJ', 'FL76 NGE', 'FR76 VAG', 'FR76 VAJ',
  'GA76 AJU', 'GB76 AZA', 'GB76 HAD', 'GB76 RUS', 'GB76 UKR', 'GE76 AJU',
  'GE76 ASH', 'GE76 AYS', 'GE76 AYX', 'GE76 AYY', 'GE76 AYZ', 'GE76 AZA',
  'GE76 BJS', 'GE76 BJX', 'GE76 BJZ', 'GE76 BOM', 'GE76 GUN', 'GE76 JEU',
  'GE76 JUW', 'GE76 KYK', 'GE76 LEZ', 'GE76 LOW', 'GE76 LSD', 'GE76 MPS',
  'GE76 MPX', 'GE76 MPZ', 'GE76 NGR', 'GE76 NGZ', 'GE76 NOG', 'GE76 OGS',
  'GE76 OGZ', 'GE76 OMB', 'GE76 ONG', 'GE76 PAK', 'GE76 PKY', 'GE76 PUS',
  'GE76 RUS', 'GE76 STD', 'GE76 VAG', 'GE76 VAJ', 'GG76 HAD', 'GO76 ASH',
  'GO76 AZA', 'GO76 BOM', 'GO76 FKT', 'GO76 FWC', 'GO76 HAD', 'GO76 JEU',
  'GO76 JUW', 'GO76 KYK', 'GO76 LSD', 'GO76 NGR', 'GO76 NGZ', 'GO76 OGS',
  'GO76 OGZ', 'GO76 OMB', 'GO76 PAK', 'GO76 PKY', 'GO76 RUS', 'GO76 SHT',
  'GO76 STD', 'GO76 UKR', 'GO76 VAG', 'GO76 VAJ', 'GO76 WAR', 'GU76 AJU',
  'GU76 AY*', 'GU76 AZA', 'GU76 FWC', 'GU76 GAY', 'GU76 JEU', 'GU76 JUW',
  'GU76 KYK', 'GU76 LEZ', 'GU76 MPS', 'GU76 MPX', 'GU76 MPZ', 'GU76 NGR',
  'GU76 NGZ', 'GU76 NOG', 'GU76 PAK', 'GU76 PKY', 'GU76 VAG', 'GU76 VAJ',
  'GY76 PED', 'HE76 OLA', 'HE76 ULA', 'HH76 ASD', 'HH76 MAS', 'HH76 NAZ',
  'HH76 OMB', 'HH76 OMO', 'HH76 TED', 'HH76 TES', 'HH76 TLR', 'HH76 WAR',
  'HO76 ASH', 'HO76 BJS', 'HO76 BJX', 'HO76 BJZ', 'HO76 COX', 'HO76 CST',
  'HO76 VAG', 'HO76 VAJ', 'JE76 HAD', 'JG76 HAD', 'JJ76 HAD', 'JU76 AGD',
  'JU76 CMP', 'JU76 NAS', 'JU76 NAZ', 'JU76 OMB', 'JU76 OVN', 'LE76 ZAA',
  'LE76 ZAR', 'LE76 ZAS', 'LE76 ZAX', 'LE76 ZAY', 'LE76 ZAZ', 'LE76 ZBO',
  'LE76 ZER', 'LE76 ZRR', 'LE76 ZRS', 'LE76 ZZA', 'LE76 ZZR', 'MP76 GUN',
  'MP76 KLR', 'MP76 OMB', 'MP76 UNN', 'MP76 UNS', 'MP76 UNX', 'MP76 UNZ',
  'MR76 ANJ', 'MR76 ONG', 'NA76 TZY', 'NA76 ZEE', 'NA76 ZZE', 'NE76 NOG',
  'NE76 RO*', 'NE76 RRO', 'NO76 AY*', 'NO76 AZA', 'NO76 LAC', 'NO76 LAK',
  'NO76 LEZ', 'NO76 OG*', 'NO76 RUS', 'NO76 UKR', 'NU76 JOB', 'NU76 RAB',
  'NU76 SAC', 'NU76 SAK', 'NU76 STD', 'NU76 VAG', 'NU76 VAJ', 'NY76 NOG',
  'OF76 GAT', 'OF76 OTS', 'OF76 OTT', 'OR76 GYS', 'OR76 GYX', 'OR76 GYY',
  'OR76 GYZ', 'OR76 YBJ', 'OR76 YES', 'OR76 YEZ', 'OR76 YFK', 'OR76 YHO',
  'OR76 YSS', 'OR76 YSX', 'OR76 YSZ', 'OR76 YXX', 'OR76 YYS', 'OR76 YYX',
  'OR76 YYY', 'OR76 YYZ', 'OR76 YZZ', 'OU76 AZA', 'OU76 LAK', 'OU76 RUS',
  'OU76 UKR', 'OW76 NKR', 'PA76 VAG', 'PA76 VAJ', 'PE76 MUF', 'PE76 NOB',
  'PE76 VAG', 'PE76 VAJ', 'PM76 GUN', 'PM76 KLR', 'PM76 OMB', 'PM76 UNN',
  'PM76 UNS', 'PM76 UNX', 'PM76 UNZ', 'PS76 CHO', 'PU76 OMB', 'RA76 AZA',
  'RA76 HED', 'RE76 ARD', 'RE76 RDD', 'RE76 RDS', 'RE76 RDU', 'RE76 RDX',
  'RE76 RDZ', 'RE76 RRD', 'RE76 TAD', 'RE76 TRD', 'RO76 AZA', 'RO76 HAD',
  'RO76 VAG', 'RO76 VAJ', 'RR76 PED', 'RR76 PER', 'RR76 PES', 'RR76 PEU',
  'RR76 PEX', 'RR76 PEY', 'RU76 RUS', 'RU76 UKR', 'SE76 OMB', 'SH76 AGS',
  'SH76 AGZ', 'SH76 ATZ', 'SH76 GED', 'SH76 GGD', 'SH76 GGS', 'SH76 GGZ',
  'SH76 HAG', 'SH76 TTY', 'SK76 NKK', 'SK76 NKS', 'SK76 NKY', 'SK76 NKZ',
  'SK76 NNK', 'SL76 GG*', 'SL76 GSS', 'SL76 GSX', 'SL76 GZX', 'SL76 GZZ',
  'SL76 UTS', 'SP76 SSS', 'SP76 STC', 'SP76 ZEE', 'SP76 ZES', 'SP76 ZYY',
  'SP76 ZZY', 'SP76 ZZZ', 'SS76 ABS', 'SS76 ABZ', 'SS76 AGU', 'SS76 ASD',
  'SS76 BBB', 'SS76 BBS', 'SS76 BBY', 'SS76 BED', 'SS76 BSS', 'SS76 BZZ',
  'SS76 ERM', 'SS76 MBO', 'ST76 ABB', 'ST76 ABS', 'ST76 ABU', 'ST76 ABX',
  'ST76 ABZ', 'ST76 BBB', 'ST76 BBD', 'ST76 BBS', 'ST76 BBY', 'ST76 BBZ',
  'ST76 BED', 'ST76 BER', 'ST76 BES', 'ST76 BSS', 'ST76 BUU', 'SU76 CDE',
  'TA76 BAN', 'TO76 ASH', 'TO76 RAB', 'TR76 ANY', 'TR76 NNY', 'TU76 VAG',
  'TU76 VAJ', 'UA76 RSE', 'UD76 RKY', 'UF76 GAT', 'UF76 GGY', 'UF76 GGZ',
  'UF76 GSS', 'UF76 GTT', 'UF76 GTZ', 'UF76 GUT', 'UF76 OTS', 'UF76 OTT',
  'UF76 OTZ', 'UK76 AZA', 'UK76 HAD', 'UK76 OMB', 'UK76 ONE', 'UK76 RUS',
  'UK76 UKR', 'UN76 OMB', 'UN76 RRZ', 'UN76 RUS', 'UN76 UKR', 'UP76 AZA',
  'UP76 RSE', 'UP76 RUS', 'UP76 UKR', 'UP76 WAR', 'UR76 AY*', 'UR76 WAT',
  'US76 AZA', 'US76 OMB', 'US76 RUS', 'US76 UKR', 'US76 WAR', 'UW76 NKR',
  'VA76 GNA', 'VD76 AY*', 'VO76 RUS', 'VO76 UKR', 'WA76 RUS', 'WA76 UKR',
  'WE76 ASH', 'WE76 BJS', 'WE76 BJX', 'WE76 BJZ', 'WE76 BUT', 'WE76 COX',
  'WE76 DYK', 'WE76 FWF', 'WE76 MUF', 'WE76 NOB', 'WE76 ONK', 'WE76 OOB',
  'WE76 PRC', 'WE76 PRK', 'WE76 PUS', 'WE76 VAG', 'WE76 VAJ', 'WE76 XBJ',
  'WO76 BLK', 'WO76 VAG', 'WO76 VAJ', 'WW76 NKR', 'WW76 NKZ', 'XG76 HAD',
  'XH76 MAS', 'XJ76 HAD', 'XS76 ABU', 'XW76 NKR', 'YE76 AZA', 'YE76 MEN',
  'YE76 RUS', 'YE76 UKR', 'YW76 NKR',
];

export const BANNED_76_WILDCARDS: string[] = [
  '**76 OOK',
  '**76 YPO',
  '*F76 GOT',
  '*N76 ERR',
  '*N76 ERS',
  '*N76 ERZ',
  '*N76 GAA',
  '*N76 NOG',
  '*T76 NNY',
  '*W76 NKS',
];

export const BANNED_76_TOTAL = BANNED_76_PLATES.length + BANNED_76_WILDCARDS.length;

// ----- Categorised buckets ----------------------------------------------
//
// Best-effort substring classifier over the trailing letters of each
// registration. Runs offline (see /tmp/classify_banned.py used during build)
// and produces the five trial-HTML categories. The "War and politics" bucket
// renders under the `other` enum slot because BannedCategory only declares
// crude | slur | drugs | death_violence | other.
//
// This is heuristic — patterns like RUS/UKR/HAD/AZA/LAH are high-confidence,
// but the "crude" bucket is the catch-all and includes some ambiguous
// entries that a more accurate classifier might re-bin. Replace with the
// LLM classifier output (handoff §5.3) when that lands; the page template
// reads `data.banned.groups` exactly the same way regardless of source.
//
// Each group's `samplePlates` shows 9 evenly-spaced examples from the bucket
// so the visible pills aren't all alphabetical neighbours.
//
// Distribution for series 76 (513 total): crude 362, slur 40, drugs 13,
// war/politics 98, death/violence 0 (hidden when count is zero).

export const BANNED_76_GROUPS = [
  {
    label: 'Crude language',
    category: 'crude' as const,
    count: 362,
    samplePlates: ['AA76 RSE', 'BJ76 UYX', 'EA76 OOB', 'GE76 AYX', 'GU76 VAG', 'NO76 LAK', 'PM76 UNS', 'SL76 UTS', 'UA76 RSE'],
  },
  {
    label: 'Slurs and offensive terms',
    category: 'slur' as const,
    count: 40,
    samplePlates: ['AA76 RYN', 'CU76 JAP', 'CU76 PAK', 'GE76 JUW', 'GE76 NOG', 'GO76 NGR', 'GU76 JUW', 'GU76 PAK', 'NO76 LEZ'],
  },
  {
    label: 'Drug references',
    category: 'drugs' as const,
    count: 13,
    samplePlates: ['CO76 ASH', 'CU76 ASH', 'EA76 ASH', 'FA76 ASH', 'FK76 ASH', 'GE76 LSD', 'GO76 ASH', 'HO76 ASH', 'TO76 ASH'],
  },
  {
    label: 'War and politics',
    category: 'other' as const,
    count: 98,
    samplePlates: ['AA76 LAH', 'EU76 GON', 'GB76 AZA', 'GO76 RUS', 'JG76 HAD', 'OU76 AZA', 'SE76 OMB', 'UP76 RUS', 'WA76 RUS'],
  },
];
